import { render, staticRenderFns } from "./BottomMainNav.vue?vue&type=template&id=d8f5b580&scoped=true&"
import script from "./BottomMainNav.vue?vue&type=script&lang=ts&"
export * from "./BottomMainNav.vue?vue&type=script&lang=ts&"
import style0 from "./BottomMainNav.vue?vue&type=style&index=0&id=d8f5b580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f5b580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBottomNavigation,VBtn,VDivider,VIcon})
